export default "__VITE_ASSET__ClFfkEFj__"